import React from 'react';
import Icon from '../../../components/AppIcon';

const CanvasPreview = ({ canvasData }) => {
  const getCompletionColor = (completion) => {
    if (completion >= 80) return 'success';
    if (completion >= 60) return 'warning';
    return 'error';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 elevation-sm">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name="Grid3x3" size={20} color="var(--color-primary)" />
        </div>
        <div>
          <h3 className="text-lg font-heading font-semibold text-foreground">
            Canvas Summary Preview
          </h3>
          <p className="text-sm text-muted-foreground font-caption">
            Condensed view of your business model canvas
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {canvasData?.blocks?.map((block) => {
          const colorClass = getCompletionColor(block?.completion);
          return (
            <div
              key={block?.id}
              className="border border-border rounded-lg p-3 hover:elevation-sm transition-smooth"
            >
              <div className="flex items-start justify-between mb-2">
                <h4 className="text-sm font-heading font-semibold text-foreground">
                  {block?.title}
                </h4>
                <div className={`px-2 py-0.5 rounded-md bg-${colorClass}/20`}>
                  <span className={`text-xs font-medium text-${colorClass} font-caption`}>
                    {block?.completion}%
                  </span>
                </div>
              </div>
              <p className="text-xs text-muted-foreground font-body line-clamp-2">
                {block?.value || 'Not completed'}
              </p>
              <div className="mt-2 h-1.5 bg-muted rounded-full overflow-hidden">
                <div
                  className={`h-full bg-${colorClass} transition-smooth`}
                  style={{ width: `${block?.completion}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-4 pt-4 border-t border-border">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground font-body">Overall Canvas Completion</span>
          <span className="font-heading font-semibold text-foreground">
            {canvasData?.overallCompletion}%
          </span>
        </div>
      </div>
    </div>
  );
};

export default CanvasPreview;